import { Flex, Text } from 'ui';
import { useFormatChatDayDividerLabel } from '../hooks';

type P = {
  date: Date;
};

const ChatDayDivider = ({ date }: P) => {
  const label = useFormatChatDayDividerLabel(date);

  return (
    <Flex align="center" justify="center">
      <Text type="secondary">{label}</Text>
    </Flex>
  );
};

export default ChatDayDivider;
